import { ResponseModal2Component } from './../../components/response-modal2/response-modal2.component';
import { ConfigService } from './../../services/config/config.service';
import { AuthenticationService } from './../../services/authentication.service';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { Component, OnInit, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from '../../services/storage.service';
import { AsistenteService } from '../../services/assistant/asistente.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { User } from '../../models/user';
import { ENPOINT } from '../../services/endpoint';
import { JSONP_ERR_NO_CALLBACK } from '@angular/common/http/src/jsonp';
import { GeneralService } from './../../services/admin/general.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [AuthenticationService, GeneralService, ConfigService]
})
export class HomeComponent implements OnInit {
  public user: User;
  title = 'app';
  isParaActive = true;
  isBtnActive = true;

  rol;
  permisos;
  permiso;
  p;
  verModulosProveedor = false;
  verModulosAdmin = false;
  verFactsOC = false;
  verFactsSOC = false;
  verReportes = false;
  verComplementos = false;
  verFacturas = false;
  verAnticiposNC = false;
  verFactsRefOC = false;
  verFactsRefEC = false;
  verFactsBatch = false;
  verComplementosPais: boolean;
  verComprobantes = false;

  complementosProveedor;
  len = ENPOINT.len;

  // Codigo Chat
  public chatOpen: boolean = false;
  listenFunc: Function;
  closeChatFunc: Function;
  sendMessageFunc: Function;

  @ViewChild('floatingChat') floatingChat: ElementRef;
  //

  closeResult;
  modal;

  constructor(
    private router: Router,
    private general: GeneralService,
    private config: ConfigService,
    private authenticationService: AuthenticationService,
    private modalService: NgbModal,
    private _router: Router,
    private storageService: StorageService,
    private renderer: Renderer2,
    private asistente: AsistenteService
  ) {

  }

  ngOnInit() {
    if (!this.storageService.isAuthenticated()) {
      this.router.navigate(['/login']);
    }

    this.noBack();
    this.modulo(); 
    this.user = this.storageService.getCurrentUser();
    this.mostrarModulo();
    this.isParaActive = !this.isParaActive;
    // this.listenFunc = this.renderer.listen(this.floatingChat.nativeElement, 'click', this.openChat.bind(this));
    // this.firstMessage();
    if (this.user) {
      if (this.user.rol.id == 3) {
        if (this.user.pais == 'MX') {
          this.mensajeBienvenida();
        } else {
          this.mensajeBienvenidaExt();
        }
      }
    }
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('Home').subscribe(
      data => {
        // console.log(data);

      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  mensajeBienvenida() {
    this.config.obtenerConfiguracionMensaje('mensaje_bienvenida').subscribe(
      data => {
        if (data !== null) {
          const modalRef = this.modalService.open(ResponseModal2Component, { centered: true, keyboard: false, backdrop: 'static' });
          modalRef.componentInstance.titulo = data.propiedad.valorLow;
          modalRef.componentInstance.mensaje1 = data.propiedad.valorHigh;

          modalRef.result.then((result) => {
            // console.log(result);

          });
        }
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  mensajeBienvenidaExt() {
    this.config.obtenerConfiguracionMensaje('mensaje_bienvenida_usd').subscribe(
      data => {
        if (data !== null) {
          const modalRef = this.modalService.open(ResponseModal2Component, { centered: true, keyboard: false, backdrop: 'static' });
          modalRef.componentInstance.titulo = data.propiedad.valorLow;
          modalRef.componentInstance.mensaje1 = data.propiedad.valorHigh;

          modalRef.result.then((result) => {
            // console.log(result);

          });
        }
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  toggleColor() {
    const x = document.getElementById('sidebar').style.width;
  }

  firstMessage() {
    var messages = this.floatingChat.nativeElement.querySelector('.messages');
    let first;
    if (this.len === 'ES') {
      first = this.renderer.createText('¡Hola! ¿Me puedes dar el código de error? ');
    } else {
      first = this.renderer.createText('Hi! Can you give me the error code? ');
    }
    let firstEl = this.renderer.createElement('li');
    this.renderer.addClass(firstEl, 'self');
    this.renderer.appendChild(firstEl, first);
    this.renderer.appendChild(messages, firstEl);
  }

  toggleClass() {
    this.isParaActive = !this.isParaActive;
    this.isBtnActive = !this.isBtnActive;
    this.toggleColor();
  }

  mostrarModulo() {
    this.rol = this.user.rol.id;
    this.permisos = this.user.permisos;
    if (this.rol === 3) {
      this.verModulosProveedor = true;
      this.verComprobantes = true;
      this.verFactsSOC = true
      if (this.user.pais == "MX") {
        this.verComplementosPais = true;
      } else {
        this.verComplementosPais = false;
      }
    } else if (this.rol === 1) {
      this.verModulosAdmin = true;
    } else if (this.rol === 2) {
      
      if (this.permisos !== undefined) {
        if (this.permisos.length !== undefined && this.permisos.length > 0) {
          for (let i = 0; i < this.permisos.length; i++) {
            this.permiso = this.permisos[i].id;

            // console.log(this.permiso);
            if (this.permiso === 1) {
              this.verFactsOC = true;
            }
            if (this.permiso === 2) {
              this.verFactsSOC = true;
            }
            if (this.permiso === 3) {
              this.verReportes = true;
            }
            if (this.permiso === 4) {
              this.verComplementos = true;
            }
            if (this.permiso === 5) {
              this.verFacturas = true;
            }
            if (this.permiso === 6) {
              this.verAnticiposNC = true;
            }
            if (this.permiso === 7) {
              this.verFactsRefOC = true;
            }
            if (this.permiso === 8) {
              this.verFactsRefEC = true;
            }
            if (this.permiso === 9) {
              this.verFactsBatch = true;
            }
            if (this.permiso === 10) {
              this.verComprobantes = true;
            }

          }
        } else {
          this.p = this.permisos.id;
          // console.log(this.p);
          if (this.p === 1) {
            this.verFactsOC = true;
          }
          if (this.p === 2) {
            this.verFactsSOC = true;
          }
          if (this.p === 3) {
            this.verReportes = true;
          }
          if (this.p === 4) {
            this.verComplementos = true;
          }
          if (this.p === 5) {
            this.verFacturas = true;
          }
          if (this.permiso === 6) {
            this.verAnticiposNC = true;
          }
          if (this.permiso === 7) {
            this.verFactsRefOC = true;
          }
          if (this.permiso === 8) {
            this.verFactsRefEC = true;
          }
          if (this.p === 10) {
            this.verComprobantes = true;
          }
        }
      }
    }

    if (this.user && this.user.id && String(this.user.id).includes('OK')) {
      this.verFactsSOC = false
      
    }
  }


  logOut() {
    this.authenticationService.cerrarSesion().subscribe(
      data => {
        this.storageService.removeCurrentSession();
        this._router.navigate(['/login']);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  ngAfterViewInit() {
    setTimeout(() => this.primerInicioSesion());
  }

  primerInicioSesion() {
    if (this.user['passwordReset'] == true) {
       this.modalService.open(ChangePasswordComponent, { centered: true, keyboard: false, backdrop: 'static' });
    }
    
  }


  openChangePassword(content) {
    this.modal = this.modalService.open(ChangePasswordComponent, { centered: true, keyboard: false, backdrop: 'static' });
    this.modal.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  //Codigo Chat
  openChat(el) {

    var messages = this.floatingChat.nativeElement.querySelector('.messages');
    var textInput = this.floatingChat.nativeElement.querySelector('.text-box');
    let chat = this.floatingChat.nativeElement.querySelector('.chat');
    let sendMessageButton = this.floatingChat.nativeElement.querySelector('#sendMessage');
    let iconChat = this.floatingChat.nativeElement.querySelector('i');
    let buttonChat = this.floatingChat.nativeElement.querySelector('.header button');
    this.renderer.setAttribute(iconChat, 'hidden', 'true');

    this.renderer.addClass(this.floatingChat.nativeElement, 'expand');
    this.renderer.addClass(chat, 'enter');

    messages.scrollTop = messages.scrollHeight;

    this.sendMessageFunc = this.renderer.listen(sendMessageButton, 'click', this.sendMessage.bind(this));
    //  this.closeChatFunc = this.renderer.listen(buttonChat, 'click',this.closeChat.bind(this) );

    this.listenFunc();

  }

  closeChat() {

    this.renderer.removeClass(this.floatingChat.nativeElement, 'expand');

    var messages = this.floatingChat.nativeElement.querySelector('.messages');
    var textInput = this.floatingChat.nativeElement.querySelector('.text-box');
    let chat = this.floatingChat.nativeElement.querySelector('.chat');

    let iconChat = this.floatingChat.nativeElement.querySelector('i');
    this.renderer.removeAttribute(iconChat, 'hidden');

    this.renderer.removeClass(chat, 'enter');

    this.sendMessageFunc();
    // this.closeChatFunc();

    setTimeout(() => {
      this.listenFunc = this.renderer.listen(this.floatingChat.nativeElement, 'click', this.openChat.bind(this));

    }, 500);


  }



  sendMessage(e) {

    if ((e.keyCode === 13 && !e.shiftKey) || e.type === 'click') {

      let newMessage = this.floatingChat.nativeElement.querySelector('.text-box');

      let code = (newMessage.value).trim();

      newMessage.value = '';

      if (code != '' && code.trim() != '') {
        let regex = /(\d+)/g;
        let messages = this.floatingChat.nativeElement.querySelector('.messages');

        let text = this.renderer.createText(code);
        let msg = this.renderer.createElement('li');
        this.renderer.addClass(msg, 'other');
        this.renderer.appendChild(msg, text);
        this.renderer.appendChild(messages, msg);
        messages.scrollTop = messages.scrollHeight;

        code = code.match(regex);
        let cod = Number(code);

        if (cod == 0) {
          let invalid, ask;
          if (this.len == 'ES') {
            invalid = this.renderer.createText('Ese no es un código de error :(');
            ask = this.renderer.createText('¿Me podrías dar un código de error valido?');
          }
          else {
            invalid = this.renderer.createText('That isn\'t an error code :(');
            ask = this.renderer.createText('Could you give me a valid error code?');
          }

          let invalidLi = this.renderer.createElement('li');
          this.renderer.addClass(invalidLi, 'self');
          this.renderer.appendChild(invalidLi, invalid);
          this.renderer.appendChild(messages, invalidLi);

          let askLi = this.renderer.createElement('li');
          this.renderer.addClass(askLi, 'self');
          this.renderer.appendChild(askLi, ask);
          this.renderer.appendChild(messages, askLi);
          messages.scrollTop = messages.scrollHeight;
          newMessage.innerHTML = '';
        }//
        else {
          this.asistente.getSolution(cod).subscribe(
            data => {

              let response = data.message;
              let first;

              if (data.status == 200) {
                if (this.len == 'ES') {
                  first = this.renderer.createText('Puedes intentar lo siguiente: ');
                }
                else {
                  first = this.renderer.createText('You can try this: ');
                }

                let firstEl = this.renderer.createElement('li');
                this.renderer.addClass(firstEl, 'self');
                this.renderer.appendChild(firstEl, first);
                this.renderer.appendChild(messages, firstEl);

              }
              messages.scrollTop = messages.scrollHeight;


              let strSplit = response.split('\n');


              for (var i = 0; i < strSplit.length; ++i) {
                let textRe = this.renderer.createText(strSplit[i]);
                let msgRe = this.renderer.createElement('li');
                this.renderer.addClass(msgRe, 'self');
                this.renderer.appendChild(msgRe, textRe);
                this.renderer.appendChild(messages, msgRe);


              }

              this.firstMessage();
              newMessage.value = '';
            },
            err => {
              let error;

              if (this.len == 'ES') {
                error = this.renderer.createText('¡Ups! Algo anduvo mal. Vuelve a intentarlo');
              }
              else {
                error = this.renderer.createText('Ups! Something went wrong. Try again');
              }

              let errorLi = this.renderer.createElement('li');
              this.renderer.addClass(errorLi, 'self');
              this.renderer.appendChild(errorLi, error);
              this.renderer.appendChild(messages, errorLi);

            }
          );
        }
      }

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/home/home.component.ts